import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFarbwelt, useScrollEffect } from "@/hooks";
import { Box } from "@gemini/core";
import { useRef } from "react";
import { FarbweltTeaser } from "./FarbweltTeaser";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { AdSlotIds } from "@/shared/types";
import { AdContainer } from "@/components/Ads/components/AdContainer";
import { useShowAds } from "@/components/Ads/hooks/useShowAds";
import { useIsPubstackEnabled } from "@/components/Ads/utils/utils";
export const FarbweltTeaserAndMediumRectangle = ({ initialTopOffset = 150, }) => {
    const { teasers } = useFarbwelt();
    const isPreviewMode = useIsPreviewMode();
    const { showSection } = useShowAds();
    const teaserTop = Array.isArray(teasers) &&
        (teasers === null || teasers === void 0 ? void 0 : teasers.find((teaser) => teaser.type === "MediumRectangleTop"));
    const showMediumRectangle2 = showSection([AdSlotIds.AD_MEDIUM_RECTANGLE_2]);
    const isPubstackEnabled = useIsPubstackEnabled();
    const adRectangle1 = useRef(null);
    const adRectangle2 = useRef(null);
    const containerRef = useRef(null);
    const { pinnedAd1, ad1Top } = useScrollEffect(
    // @ts-ignore
    adRectangle1, adRectangle2, containerRef);
    if (isPreviewMode) {
        return null;
    }
    const shouldRenderAd = showMediumRectangle2 || !isPubstackEnabled;
    return (_jsxs(Box, { display: "flex", flex: "1", minHeight: "0", alignItems: "center", flexDirection: "column", ref: containerRef, unsafe_className: "HideOnPrint", children: [teaserTop && (_jsx(Box, { position: pinnedAd1 ? "relative" : "sticky", top: pinnedAd1 ? ad1Top : initialTopOffset, ref: adRectangle1, display: "flex", children: _jsx(FarbweltTeaser
                // @ts-ignore
                , { 
                    // @ts-ignore
                    teaser: teaserTop, av_zone: "side" }) })), teaserTop && shouldRenderAd && (_jsx(Box, { minHeight: "25%", width: "100%" })), shouldRenderAd && (_jsx(Box, { ref: adRectangle2, display: showMediumRectangle2 ? "flex" : "none", position: "sticky", top: initialTopOffset, children: _jsx(AdContainer, { adSlotId: AdSlotIds.AD_MEDIUM_RECTANGLE_2, display: {
                        "breakpoint.base": "none",
                        "breakpoint.lg": "flex",
                    }, showLabel: true, width: "300px", justifyContent: "center" }) }))] }));
};
